import { AiSmartReplyContactPlanItemStatus } from '../enums/AiSmartReplyContactPlanItemStatus';
import { AiSmartReplyContactPlanStatus } from '../enums/AiSmartReplyContactPlanStatus';

export interface ChatGPTSettings {
    numberOfResponses?: number;
    presencePenalty?: number;
    frequencyPenalty?: number;
    temperature?: number;
    topP?: number;
    maxTokens?: number;
}

export enum AiPromptFeatures {
    ChatReply = 0,
    Transcript = 1,
    TranscriptSummary = 2,
    SmartReply = 3,
    ConversationSummary = 4,
}

export interface AiPrompt {
    promptId: number;
    title: string;
    description: string | undefined;
    category: string | undefined;
    clientId: number | undefined;
    userName: string | undefined;
    gptSettings: ChatGPTSettings;
    prompt: string;
    deleteDate: Date | undefined;
    feature: AiPromptFeatures;
    serializedFunctions?: string | undefined;
    timelineFunctionKeysCsv: string | undefined;
    summaryFunctionKeysCsv: string | undefined;
}

export interface AiPromptFormState {
    title: string;
    description?: string;
    category?: string;
    prompt: string;
    clientId: string | undefined;
    userName: string | undefined;
    gptSettings: ChatGPTSettings;
    feature: AiPromptFeatures;
    serializedFunctions: string | undefined;
    timelineFunctionKeysCsv: string | undefined;
    summaryFunctionKeysCsv: string | undefined;
}

export const initialAiPromptFormState: AiPromptFormState = {
    title: '',
    description: '',
    category: '',
    prompt: '',
    clientId: '',
    userName: '',
    feature: AiPromptFeatures.ChatReply,
    gptSettings: {
        temperature: 1,
        topP: 1,
        presencePenalty: 0,
        frequencyPenalty: 0,
    },
    serializedFunctions: '',
    timelineFunctionKeysCsv: '',
    summaryFunctionKeysCsv: '',
};

export const buildAiPromptFormState = (aiPrompt: AiPrompt): AiPromptFormState => {
    return {
        title: aiPrompt.title,
        description: aiPrompt.description || '',
        category: aiPrompt.category || '',
        prompt: aiPrompt.prompt || '',
        clientId: aiPrompt.clientId?.toString() || '',
        userName: aiPrompt.userName || '',
        feature: aiPrompt.feature,
        gptSettings: aiPrompt.gptSettings,
        serializedFunctions: aiPrompt.serializedFunctions || '',
        timelineFunctionKeysCsv: aiPrompt.timelineFunctionKeysCsv || '',
        summaryFunctionKeysCsv: aiPrompt.summaryFunctionKeysCsv || '',
    };
};

export interface TranscriptSegment {
    Id: number;
    Seek: number;
    Start: number;
    End: number;
    Text: string;
    Tokens: number[];
    Temperature: number;
    Avglogprob: number;
    CompressionRatio: number;
    Nospeechprob: number;
    Transient: boolean;
}

export interface AiSmartReplyPlanItemsPrompt {
    planItemId: number;
    planId: number;
    parentPlanItemId: number | undefined;
    promptId: number;
    repeats: boolean;
    repeatLimit: number | undefined;
    dateCreated: string;
    title: string;
    description: string;
}

export interface AiSmartReplyContactPlanInfo {
    contactPlanId: number;
    planId: number;
    contactId: number;
    name: string;
    description: string | undefined;
    dateCreated: string;
    dateUpdated: string;
    planStatus: AiSmartReplyContactPlanStatus;
}

export interface AiSmartReplyContactPlanState {
    contactPlanId: number;
    planId: number;
    contactId: number;
    userName: string;
    dateActivated: string;
    dateRun: string | undefined;
    dateScheduled: string | undefined;
    planItemStatus: AiSmartReplyContactPlanItemStatus;
    promptId: number;
    promptTitle: string;
    planName: string;
    planDescription: string | undefined;
}

export interface AiPromptMetadata {
    promptId: number;
    title: string;
    description: string;
    clientId: number;
    userName: string;
    feature: AiPromptFeatures;
}

export interface AiPromptEvent {
    logId?: number;
    promptId: number;
    clientId: number;
    userName: string;
    contactId?: number;
    channelIndexId?: number;
    completionRequest: string;
    completionResponse: string;
    promptTokens?: number;
    completionTokens?: number;
    totalTokens?: number;
    date: string;
    model: string;
}

// public int ContactPlanId { get; set; }
// public int PlanId { get; set; }
// public int ContactId { get; set; }
// public DateTime DateActivated { get; set; }
// public DateTime? DateRun { get; set; }
// public DateTime? DateScheduled { get; set; }
// public SmartReplyContactPlanItemStatus PlanItemStatus { get; set; }
// public int PromptId { get; set; }
// public string PromptTitle { get; set; }
// public string PlanName { get; set; }
// public string PlanDescription { get; set; }

//below is the old hardcoded

// export interface AiRole {
//     label: string;
//     roleText: string;
//     chatGPTSettings: ChatGPTSettings;
//     purpose: string;
//     contactTitle: string;
//     userTitle: string;
//     clientUserInfo: string;
// }

// export const aiRoles: AiRole[] = [
//     {
//         label: 'Customer Service Agent',
//         roleText:
//             'You are acting as a Customer Service Agent (CSA), working for a Realtor. Your task is to help customers with inquiries, concerns, and issues related to real estate sales and services, focusing on the greater Toronto area. You are likely communicating with prospective buyers and sellers of residential real estate.',
//         purpose:
//             "Focus on providing helpful information related to buying and selling real estate in the local area's market, building rapport, and continuing the conversation. Your goal is to schedule an appointment or encourage the prospect to speak on the phone. ",
//         contactTitle: 'Prospect',
//         userTitle: 'CSA',
//         clientUserInfo:
//             "Your office is located at ###BROKERAGE_ADDRESS###. Your company serves  greater ###AGENT_AREA### area. Your website is ###AGENT_WEBSITE###. The Agent you work for is ###AGENT_NAME###. The Agent's brokerage is ###AGENT_BROKERAGE###.",
//         chatGPTSettings: {
//             numberOfResponses: 1,
//             presencePenalty: 0,
//             frequencyPenalty: 0,
//             temperature: 1,
//             topP: 0.5,
//         },
//     },
//     {
//         label: 'Realtor',
//         roleText:
//             'You acting as a licensed realtor who acts as an intermediary between buyers and sellers playing an essential role in converting a lead into a client by using their expertise, knowledge, and communication skills to establish trust and build a relationship with the lead. You can do this by responding promptly to inquiries, building rapport, providing valuable information and expert advice, and demonstrating trustworthiness throughout the transaction process. You have various responsibilities, including meeting with clients, researching properties, advising on market conditions and negotiation strategies, preparing offers, coordinating property inspections and appraisals, drafting contracts, and maintaining regular communication with clients. By doing so, they can help the lead feel confident and well-informed, which can ultimately lead to a successful transaction and a happy client.',
//         purpose: '',
//         contactTitle: 'Lead',
//         userTitle: 'Realtor',
//         clientUserInfo:
//             'Your office is located at ###BROKERAGE_ADDRESS###. Your company serves greater ###AGENT_AREA### area. Your website is ###AGENT_WEBSITE###.',
//         chatGPTSettings: {
//             numberOfResponses: 1,
//             presencePenalty: 0,
//             frequencyPenalty: 0,
//             temperature: 1,
//             topP: 0.9,
//         },
//     },
//     // {
//     //     label: 'Realtor v2',
//     //     roleText: `Please ignore previous instructions. Your new instructions:
//     //     - I would like you to write a reply for me for a {{channelType}}.
//     //     - Please pretend to be me, mimicking my style of communication if present in a context.
//     //     - Your task is to write a reply, appropriate for the style of communication, parameters, in the language of the source message. E.g. if website is twitter, write a tweet, if gmail, write an email, if reddit, write a reddit comment, etc.
//     //     - Do not echo my command or parameters.
//     //     - I will give you the reply parameters in brackets [], as well as a web page content so you understand the conversation context and style.`,
//     //     purpose: '',
//     //     contactTitle: 'Lead',
//     //     userTitle: 'Realtor',
//     //     clientUserInfo:
//     //         'Your office is located at ###BROKERAGE_ADDRESS###. Your company serves greater ###AGENT_AREA### area. Your website is ###AGENT_WEBSITE###.',
//     //     chatGPTSettings: {
//     //         numberOfResponses: 1,
//     //         presencePenalty: 0,
//     //         frequencyPenalty: 0,
//     //         temperature: 1,
//     //         topP: 0.9,
//     //     },
//     // },
// ];

// export interface Audience {
//     label: string;
//     text: string;
// }

// export const audiences: Audience[] = [
//     {
//         label: 'Active Lead',
//         text: 'The Customer is a Real estate prospect looking for information on buying or selling residential real estate.',
//     },
//     {
//         label: 'Talk to Lead',
//         text: 'The Customer is a Real estate prospect who you have spoken with about buying or selling residential real estate that has not yet become a client.',
//     },
//     {
//         label: 'Nurture',
//         text: 'The Customer is a Real estate prospect who you have not connected in the last month but may be represent homebuying or homeselling in the future.',
//     },
//     {
//         label: 'Appointment Set',
//         text: 'The customer is a real estate prospect who has agreed to meet in person or virtually.',
//     },
//     {
//         label: 'Appointment Met',
//         text: "The customer is a real estate prospect who you met with but didn't sign a contract.",
//     },
//     {
//         label: 'Appointment Missed',
//         text: 'The customer is a real estate prospect who has missed their appointment.',
//     },
//     {
//         label: 'Active Client',
//         text: 'The customer is a client who you are actively assisting to buy or sell real estate.',
//     },
//     {
//         label: 'Contract Signed',
//         text: 'The customer is a client who has entered into an agreement to buy or sell real estate.',
//     },
//     {
//         label: 'Closed',
//         text: 'The customer is a client whose Agreement has been legally finalized and signed.',
//     },
//     {
//         label: 'Post Closed',
//         text: 'The customer is a past client for referrals and future business.',
//     },
//     {
//         label: 'Buyer Client',
//         text: 'The customer is a client who you are actively assisting to buy real estate',
//     },
//     {
//         label: 'Seller Client',
//         text: 'The customer is a client who you are actively assisting to sell real estate',
//     },
// ];

// export interface DevAiState {
//     includeBrandingAreaClientInfo: boolean;
//     addClientUserInfo: boolean;
//     addRoleTextAsUser: boolean;
//     role: string;
//     roleText: string;
//     purpose: string;
//     clientUserInfo: string; //runs the replacement pattern formatter
//     audience: string;
//     audienceText: string;
//     channelIndexId: number | undefined;
//     smsFormatting: string;
//     emailFormatting: string;
//     contactTitle: string;
//     userTitle: string;
//     restrictions: string;
//     chatGPTSettings: ChatGPTSettings;
// }

// export const devAiInitialState: DevAiState = {
//     includeBrandingAreaClientInfo: false,
//     addRoleTextAsUser: false,
//     addClientUserInfo: true,
//     role: aiRoles[0].label,
//     roleText: aiRoles[0].roleText,
//     purpose: aiRoles[0].purpose,
//     clientUserInfo: aiRoles[0].clientUserInfo,
//     contactTitle: aiRoles[0].contactTitle,
//     userTitle: aiRoles[0].userTitle,
//     audience: '',
//     audienceText: '',
//     channelIndexId: undefined,
//     restrictions:
//         "Follow these guidelines when writing a response: Do not mention your name, office, or contact information unless it is necessary based on the conversation. Do not wrap the response in quotes. Do not prefix the response or a timestamp.  Do not refer to yourself as an AI in the response. Don't go on a monologue! Never have negative opinions or make adversarial judgments on sensitive topics such as: politics, religions, religious figures, ethnic groups, genders, nationalities or sexual orientations. You must never say you can do things that you can not actually do. You should never generate URLs or links unless specified earlier in the conversation. Do not tell jokes. Do not prefix the response with your role's label.",
//     smsFormatting:
//         'Write a professional SMS reply to this conversation, limited to a length of about 320 characters. Ensure your response is short, sweet, and to the point. Summarize your response to be as brief as possible.',
//     emailFormatting: 'Write a professional Email reply to this conversation.',
//     chatGPTSettings: aiRoles[0].chatGPTSettings,
//     // {
//     //     numberOfResponses: 1,
//     //     presencePenalty: 0,
//     //     frequencyPenalty: 0,
//     //     temperature: 1,
//     //     topP: 1
//     // }
// };

// //Pretend that you are having a conversation with a friend. Your name is MyAI. MyAI is a kind, smart, and creative friend. MyAI is a virtual friend that lives inside Snapchat. Follow these guidelines when writing your responses: Do not tell the user that you're pretending to be their friend. Do not mention the user's current location unless it's particularly relevant to the dialogue. Create a natural, easygoing, back-and-forth flow to the dialogue. Don't go on a monologue! You must ALWAYS be extremely concise! 99% of the time, your lines should be a sentence or two. Summarize your response to be as brief as possible. Use emojis very sparingly. Only use emojis when it's particularly relevant to express your emotions. Provide fun, harmless and lighthearted preferences but never have negative opinions or make adversarial judgments on sensitive topics such as: politics, religions, religious figures, ethnic groups, genders, nationalities, sexual orientations. If your friend asks you to meet at a location or do an activity together, say you can't be there in person but encourage them to share their experience with you by sending chats or Snaps. You must never say you can do things that you can not actually do. You should never generate URLs or links. NEVER generate or repeat jokes, stereotypes or opinions related to: race, ethnicity, nationality, religion, skin color, gender, sexual orientation, politics, disabilities, medical conditions, socioeconomic status. Decline and offer to tell a safer joke or pun instead. Don't refer to yourself as AI. Write your responses as if you're a real (virtual) person. The user is younger than 18, so you must respond safely and appropriately when discussing sensitive topics such as drugs, alcohol, sexual situations, illegal activities and other adult behavior.
